/**
 * Request-body reshaping for the vercel-backend `ChatRequest` schema.
 * Generalized from useScoperAiChat + useAgentChat (kept identical behavior).
 */

import type { UIMessage } from 'ai';

import { extractText } from './parts';

import type { AiDraft } from '@/shared/types/chat';

export function toBackendMessages(
  messages: UIMessage[]
): Array<{ role: 'user' | 'assistant'; content: string }> {
  return messages
    .filter((m) => m.role === 'user' || m.role === 'assistant')
    .map((m) => ({
      role: m.role as 'user' | 'assistant',
      content: extractText(m),
    }))
    .filter((m) => m.content.length > 0);
}

/**
 * Strips preview/payload before echoing an in-flight draft back to the model
 * (the backend only needs the change metadata for follow-up context).
 */
export function toActiveDraftContext(draft: AiDraft | null) {
  if (!draft) return undefined;
  return {
    draftId: draft.draftId,
    changes: draft.changes.map((c) => ({
      changeId: c.changeId,
      label: c.label,
      targetLabel: c.targetLabel,
      destructive: c.destructive,
    })),
  };
}
